import {SecureService} from "@/services/superclasses/secure-service";
import {BarChartData} from "@/interfaces/bar-chart-data";
import {LineChartData} from "@/interfaces/line-chart-data";
import {DateTime} from "luxon";
import {PieChartData} from "@/interfaces/pie-chart-data";
import {RefCountData} from "@/interfaces/ref-count-data";

const api = window.contextPath + '/rest/posts';

export class PostStatsSecureService extends SecureService {

    public loadTimestamps = async (
        postId: number,
        from: DateTime,
        to: DateTime,
        hostId?: number
    ): Promise<LineChartData> => {
        return this.data(await this.get<LineChartData>(api + "/" + postId + "/stats/timestamps",
            {
                params: {
                    from,
                    to,
                    hostId
                }
            }))
    }

    public loadSourceRefs = async (
        postId: number,
        from: DateTime,
        to: DateTime
    ): Promise<BarChartData> => {
        return this.data(await this.get<BarChartData>(api + "/" + postId + "/stats/source-refs",
            {
                params: {
                    from,
                    to
                }
            }))
    }

    public loadNaces = async (
        postId: number,
        from: DateTime,
        to: DateTime,
        hostId?: number
    ): Promise<PieChartData> => {
        return this.data(await this.get<PieChartData>(api + "/" + postId + "/stats/naces",
            {
                params: {
                    from,
                    to,
                    hostId
                }
            }))
    }

    public loadCompanies = async (
        postId: number,
        from: DateTime,
        to: DateTime,
        hostId?: number
    ): Promise<RefCountData[]> => {
        return this.data(await this.get<RefCountData[]>(api + "/" + postId + "/stats/companies",
            {
                params: {
                    from,
                    to,
                    hostId
                }
            }))
    }

    public loadPersons = async (
        postId: number,
        from: DateTime,
        to: DateTime,
        hostId?: number
    ): Promise<RefCountData[]> => {
        return this.data(await this.get<RefCountData[]>(api + "/" + postId + "/stats/persons",
            {
                params: {
                    from,
                    to,
                    hostId
                }
            }))
    }
}

export const postStatsSecureService = new PostStatsSecureService()